export default __webpack_public_path__ + "static/media/midmanagement.4ee16ff8.jpg";